export const STORNO_CORRECTIVE_INVOICE_SENTENCE =
  'Für die korrekte Rechnung erhalten Sie eine separate Rechnung mit neuer Rechnungsnummer. Bitte entschuldigen Sie die Unannehmlichkeiten.';

export function stripStornoFixedAfterTotals<T extends { text: string }>(paras: T[]): T[] {
  return paras.filter((p) => p.text.trim() !== STORNO_CORRECTIVE_INVOICE_SENTENCE);
}
